<app-single-scrollable-container>
    <div class="d-flex flex-column align-items-center flex-grow-1 pt-5 gap-4">
        <div class="d-flex flex-column align-items-center">
            <p class="font-medium color--accent-primary font-tertiary mt-4 mb-5" style="font-size:15rem;line-height: 15rem;">
                @if(errorType() == errorTypes.NotFound){
                    404
                }
                @else if(errorType() == errorTypes.AccessDenied){
                    <fa-icon [icon]="['fad', 'hand']"/>
                }
                @else {
                    Error
                }
            </p>
            <p class="font-size-30rm font-semibold font-secondary">
                @if(errorType() == errorTypes.NotFound){
                    Page Not Found
                }
                @else if(errorType() == errorTypes.AccessDenied){
                    Access Denied
                }
                @else {
                    Something Went Wrong
                }
            </p>
            <p class="font-size-15rm font-light">
                @if(errorType() == errorTypes.NotFound){
                    The page you are looking for does not exist or has been moved.
                }
                @else if(errorType() == errorTypes.AccessDenied){
                    You do not have the proper authorisation to perform this action.
                }
                @else {
                    Please try again.
                }
            </p>
        </div>

        <div class="d-flex flex-row m-0 p-0 justify-content-center align-items-center gap-3 col-6">
                
            <hr class="col m-0 flex-grow"/>
        
            <div class="d-flex justify-content-center align-items-center">
                <a class="font-bold m-0 text-link text-nowrap" [routerLink]="['/']">Home</a>
            </div>
        
            <hr class="col m-0 flex-grow"/>
        
        </div>
    </div>
</app-single-scrollable-container>
